// extracted by mini-css-extract-plugin
export default {"prompt":"SMLUpgradeOffer_prompt__RlaED"};